<template>
  <span
    class="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-[10px] font-semibold ring-1 ring-black/5"
    :style="style"
    :title="name"
  >
    {{ initials }}
  </span>
</template>

<script>
export default {
  name: "UiAvatar",
  props: {
    name: { type: String, default: "" },
  },
  computed: {
    hue() {
      let h = 0;
      for (let i = 0; i < this.name.length; i += 1) {
        h = (h * 31 + this.name.charCodeAt(i)) % 360;
      }
      return h;
    },
    style() {
      if (!this.name) return { backgroundColor: "hsl(0 0% 55%)", color: "#fff" };
      const hue = (this.hue + 180) % 360;
      return { backgroundColor: `hsl(${hue} 52% 45%)`, color: "#fff" };
    },
    initials() {
      if (!this.name) return "?";
      return this.name
        .split(/[\s@._-]+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part[0].toUpperCase())
        .join("");
    },
  },
};
</script>
